export function getOrganizationStructuredDataJson() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'https://www.evee.com.au/#organization',
        name: 'evee',
        url: 'https://www.evee.com.au/',
        logo: 'https://www.evee.com.au/img/logo.png',
        description:
          "Australia and New Zealand's largest 100% electric car sharing platform. Rent Tesla, BYD, and other EVs from local hosts across Australia and New Zealand.",
        foundingDate: '2016',
        areaServed: [
          {
            '@type': 'Country',
            name: 'Australia',
          },
          {
            '@type': 'Country',
            name: 'New Zealand',
          },
        ],
        sameAs: [
          'https://www.facebook.com/eveecars/',
          'https://www.instagram.com/eveecars/',
          'https://x.com/eveecars',
          'https://au.linkedin.com/company/evee',
          'https://www.youtube.com/@eveecars',
          'https://www.trustpilot.com/review/evee.com.au',
          'https://www.google.com/maps/search/?api=1&query=evee+1005+Botany+Rd+Rosebery+NSW+2020',
          'https://www.google.com/maps/search/?api=1&query=evee+5%2F1+Moore+St+Canberra+ACT+2601',
        ],
      },
      {
        '@type': 'WebSite',
        '@id': 'https://www.evee.com.au/#website',
        url: 'https://www.evee.com.au/',
        name: 'evee',
        publisher: {
          '@id': 'https://www.evee.com.au/#organization',
        },
      },
    ],
  };
}

export function getFaqStructuredDataJson() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'FAQPage',
        '@id': 'https://www.evee.com.au/#faq',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Can I ask the host a question before making a booking?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "If you want to contact a host, you'll have to submit a booking request first (this opens up a direct chat line where you can ask any questions you might have). You'll only be charged for the booking if the host confirms the trip.",
            },
          },
          {
            '@type': 'Question',
            name: 'This is my first time in an EV - what do I need to know?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "When you pick up the car from the host, they'll go over all the main features with you. This handover is also a great opportunity to ask any questions you have about driving electric, e.g. 'how do I charge the car?'.",
            },
          },
          {
            '@type': 'Question',
            name: 'Can I get the car delivered?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Some hosts offer airport delivery (or delivery to a personal address) for an additional fee. Please check the vehicle listing page to see if the host delivers to your location.',
            },
          },
          {
            '@type': 'Question',
            name: 'Do I need to buy insurance?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'All vehicles rented through evee have insurance included in the rental price, with variable damage liability depending on the vehicle type. You can choose to add evee Protect to cover the damage liability if there is an accident, or for protection against things such as minor parking damage, wheel scrapes, and windscreen damage or replacements.',
            },
          },
          {
            '@type': 'Question',
            name: 'What if I damage the car?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "It is the renter's responsibility to report any damages to the host as soon as possible. evee will capture your refundable deposit for minor damages and charge the full damage liability amount for major accidents while we determine liability and repair costs. Any remaining balance will be refunded to you at the end of the assessment.",
            },
          },
          {
            '@type': 'Question',
            name: 'How do I add a driver to my booking?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'All additional drivers must make an account on evee, upload their licence and complete our driver declaration via the Personal info accounts page (otherwise they will not be covered by insurance).',
            },
          },
          {
            '@type': 'Question',
            name: 'What are the requirements for electric car rentals in Australia?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "To rent an electric car with evee, you need a valid driver's licence and a verified evee account. The licence can be Australian or international. A credit or debit card is required for payment and security purposes. Renters must meet the minimum age requirements and adhere to all local road rules as well as renting conditions set by the owner.",
            },
          },
          {
            '@type': 'Question',
            name: 'How can I find charging stations in Australia?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Finding charging stations across Australia is simple with tools like PlugShare and Google Maps, which offer real-time locations and availability of nearby stations. evee also provides a charging concierge service, which offers personalised assistance for trip planning and charging recommendations.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is there a minimum age requirement to rent an electric car at evee?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "The minimum age requirement for renting depends on the vehicle type. For standard vehicles, renters must be 25 or older, while premium and performance vehicles require renters to be 30 or older. All renters must hold a full, unrestricted driver's licence. Each listing specifies the age requirements, so review them carefully before booking.",
            },
          },
          {
            '@type': 'Question',
            name: 'What are the advantages of peer-to-peer EV rental in Australia?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "Peer-to-peer rental through evee builds and supports a community of like-minded individuals who share a passion for sustainable driving. We offer a more personable experience with a direct line to owners for immediate support. Renters also gain access to a broader range of electric car brands and models, something that's often unavailable through traditional rental platforms.",
            },
          },
          {
            '@type': 'Question',
            name: 'How do I book an electric car rental through evee?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "Booking an electric car rental through evee is simple. First, sign up or log in to your account, then search for available EVs in your location. Once you find a vehicle that suits your needs, check the rental details and requirements, then book the car directly through the platform. You'll receive confirmation from the vehicle owner, and they will provide further instructions for pickup and drop-off.",
            },
          },
          {
            '@type': 'Question',
            name: 'What is the environmental impact of driving an electric car?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: "Driving an electric vehicle significantly reduces your carbon footprint compared to traditional petrol or diesel cars. EVs produce zero tailpipe emissions and can be powered by renewable energy sources, further lowering their impact on the environment. By renting an electric car with evee, you're contributing to a more sustainable future and helping reduce air pollution in your community.",
            },
          },
        ],
      },
    ],
  };
}